import { useQuery } from "@tanstack/react-query";
import { cacheConfig, QueryKeys } from "./constants";
import { fetchHomepageData, HomePageData } from "../api/homepage";

export const useBrandConfig = (enabled?: boolean) => {
  return useQuery<HomePageData>({
    queryKey: [QueryKeys.BrandConfig],
    queryFn: fetchHomepageData,
    enabled: enabled ?? true,
    ...cacheConfig.oneHour,
  });
};
